import { createContext, useContext } from "react";

/**
 * Marketplace session state: what the logged-in user owns, what they have
 * equipped, their RP balance, and a buy() action. Provided by the
 * Marketplace route, consumed by MarketCard.
 */
export const MarketContext = createContext({
  loggedIn: false,
  loading: true,
  balance: 0,
  owned: {},     // { profile: Set, background: Set, badge: Set, font: Set, rank: Set }
  equipped: {},  // { profile: tag, background: tag, badge: Set, font: tag, rank: tag }
  buy: () => Promise.resolve({ error: "not_ready" }),
});

export const useMarket = () => useContext(MarketContext);
